import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CheckCircle, Loader2, Mail, ShoppingBag, Sparkles } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MerchPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, {
        email,
        category: "General Subscribers",
      });
      setSubmitted(true);
      toast.success("You're on the list!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Signup failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-fade-in">
      <section className="bg-[#EEF8F2] text-[#1a1a1a] border-b border-[#42D78A]/20 py-20 md:py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 rounded-full bg-[#42D78A]/10 flex items-center justify-center mx-auto mb-6">
            <ShoppingBag className="w-8 h-8 text-[#42D78A]" />
          </div>
          <p className="text-[#42D78A] text-sm tracking-[0.2em] uppercase mb-4 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>Coming Soon</p>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Shop Our Merch
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            614 Shop Local merch is on the way.
          </p>
        </div>
      </section>

      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-2xl border border-gray-100 bg-white p-8 md:p-10 shadow-sm">
            <div className="w-16 h-16 rounded-2xl bg-[#42D78A]/10 flex items-center justify-center mx-auto mb-6">
              <Sparkles className="w-8 h-8 text-[#42D78A]" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a1a1a] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Merch is always locally made.
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              We&apos;re building a small merch collection that supports the same local creative economy this platform was made for.
            </p>
            <div className="mb-8 rounded-2xl border border-gray-100 bg-gray-50 p-5 text-left">
              {submitted ? (
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#42D78A] flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-bold text-[#1a1a1a] mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                      You&apos;re subscribed
                    </h3>
                    <p className="text-sm text-gray-600" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      We&apos;ll let you know when the merch store goes live.
                    </p>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4" data-testid="merch-newsletter-form">
                  <div>
                    <h3 className="font-bold text-[#1a1a1a] mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                      Subscribe to be updated when our merch store goes live.
                    </h3>
                    <p className="text-sm text-gray-600" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      Join the general subscriber list for launch updates.
                    </p>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <div className="relative flex-1">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                      <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@email.com"
                        className="h-12 pl-10 rounded-lg border-gray-200 bg-white"
                        disabled={loading}
                      />
                    </div>
                    <Button
                      type="submit"
                      disabled={loading}
                      className="bg-[#1a1a1a] hover:bg-black text-white rounded-full px-7 py-5 text-sm font-bold"
                      style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                      {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Subscribing...</> : "Subscribe"}
                    </Button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MerchPage;
